import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'

export default function AddBusinessCategory({ businessCategory: businessCategoryData }) {
  const queryClient = useQueryClient()
  const history = useHistory()
  const [businessCategory, setBusinessCategory] = useState({
    name: businessCategoryData ? businessCategoryData.name : '',
  })

  const data = [{ label: 'Business Category Name', value: businessCategory.name, name: 'name' }]

  const [loading, setLoading] = useState(false)

  const handleClick = () => {
    setLoading(true)

    if (businessCategoryData) {
      updateDocumentByID('/business-category', businessCategoryData._id, businessCategory)
      queryClient.invalidateQueries('business-category')
      setLoading(false)
    } else {
      createDocument('/business-category', businessCategory)
      queryClient.invalidateQueries('business-category')
      setLoading(false)
    }

    history.push('/business-category')
  }

  return (
    <CustomAddPage
      heading="Business category"
      redirect={'BUSINESS_CATEGORY'}
      currentData={businessCategory}
      loading={loading}
      state={businessCategory}
      setState={setBusinessCategory}
      handleClick={handleClick}
      inputFields={data}
    />
  )
}
